import React from 'react'
import CommonImage from "@/components/common/image/CommonImage";

export default function SectionTitle({iconSrc, title, description, className = ''}) {
  return (
    <div className={`section_title ${className}`}>
        <h1 className="title">
            <span className="w-8 h-8"><CommonImage src={iconSrc} alt={"Icon"} className="img-icon" /> </span> {title}
        </h1>
        <p className="short-des">
            {description}
        </p>
    </div>
  )
}
